import { MainMenuMode } from '../types';
import theme from './theme';

const getClassesByMode = (mainMenuMode: MainMenuMode, type: string) =>
  theme[mainMenuMode][type];

export default getClassesByMode;
